module.exports = __webpack_public_path__ + "img/map3.a9a64c72.jpg";